import React, { useState, useEffect, memo, Fragment } from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import { Modal, message } from 'antd';

import { updateStdCertificateDataService } from '../../../services/UploadService';


const StdCertificateInputModal = (props) => {
    const [formValues, setFormValues] = useState({
        file_no: '',
        issuing_date: '',
        expiry_date: '',
        issuing_authority: '',
        purpose: ''
    });


    const showModal = () => {
        // setOpen(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
          ...formValues,
          [name]: value,
        });
    }

    const handleCancel = () => {
        console.log('Clicked cancel button');
        setFormValues({});
        props.handleClose();
        // setOpen(false);
    };

    const handleOk = async () => {
        console.log("update: ", formValues);
        const token = localStorage.getItem('token');
        const certId = formValues?.std_certificate_id || formValues?.id;
        
        if (!certId) {
            message.error("Invalid Certificate ID");
            return;
        }

        const payload = {
            file_no: formValues.file_no || '',
            issuing_date: formValues.issuing_date || null,
            expiry_date: formValues.expiry_date || null,
            issuing_authority: formValues.issuing_authority || '',
            purpose: formValues.purpose || ''
        };

        try {
            await updateStdCertificateDataService(certId, payload, token);
            message.success("Certificate updated successfully");
            props.handleClose();
        } catch (err) {
            console.error("Failed to update certificate:", err);
            message.error(err?.response?.data?.detail || "Failed to update certificate");
        }
    };

    useEffect(() => {
        if (props.data) {
            setFormValues(props.data);
        }
    }, [props.data, props.title, props.open]);

    return (
        <>
            <Modal
                title={"Edit " + props.title}
                open={props.open}
                // onOk={handleOk}
                // confirmLoading={confirmLoading}
                onCancel={handleCancel}
                footer={[
                    // <Button key="back" onClick={handleCancel}>
                    //   Cancel
                    // </Button>,
                    <Button key="submit" type="primary" className="cip-btn-submit" onClick={handleOk}>
                      Update
                    </Button>,
                  ]}
            >
                <Card>
                    <Card.Body>
                    {/* <Card.Title>{props.title}</Card.Title> */}
                    <hr className="hr-horizontal" />
                    <Form>
                        <Form.Group as={Row} className="mb-3" controlId="file_no">
                        <Form.Label column sm="3">File No.*</Form.Label>
                        <Col sm="9">
                            <Form.Control
                            required
                            type="text"
                            name="file_no"
                            placeholder='Enter file no.'
                            value={formValues && formValues.file_no}
                            onChange={handleInputChange}
                            style={!(formValues && formValues.file_no) ? { border: '1px solid var(--cip-danger)' } : undefined}
                            />
                        </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="issuing_date">
                        <Form.Label column sm="3">Issuing Date*</Form.Label>
                        
                        <Col sm="9">
                            {/* <DatePicker id="issuing_date" name="issuing_date" defaultValue={formValues.issuing_date} onChange={handleDateInputChange} style={{width: "50%"}} renderExtraFooter={() => 'extra footer'} /> */}
                            <Form.Control
                            required
                            type="date"
                            name="issuing_date"
                            placeholder='Enter issuing date'
                            value={formValues && formValues.issuing_date}
                            onChange={handleInputChange}
                            style={!(formValues && formValues.issuing_date) ? { border: '1px solid var(--cip-danger)' } : undefined}
                            />
                        </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="expiry_date">
                        <Form.Label column sm="3">Expiry*</Form.Label>
                        <Col sm="9">
                            <Form.Control
                            required
                            type="date"
                            name="expiry_date"
                            placeholder='Enter expiry date'
                            value={formValues && formValues.expiry_date}
                            onChange={handleInputChange}
                            style={!(formValues && formValues.expiry_date) ? { border: '1px solid var(--cip-danger)' } : undefined}
                            />
                        </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="issuing_authority">
                        <Form.Label column sm="3">Issuing Authority*</Form.Label>
                        <Col sm="9">
                            <Form.Control
                            type="text"
                            name="issuing_authority"
                            placeholder='Enter Issuing Authority'
                            value={formValues && formValues.issuing_authority}
                            onChange={handleInputChange}
                            style={!(formValues && formValues.issuing_authority) ? { border: '1px solid var(--cip-danger)' } : undefined}
                            />
                        </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-1" controlId="purposeRemarks">
                            <Form.Label column sm="3">Purpose (optional)</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                type="text"
                                name="purpose"
                                placeholder='Enter purpose'
                                value={formValues && formValues.purpose}
                                onChange={handleInputChange}
                                
                                />
                            </Col>
                        </Form.Group>

                        
                    </Form>
                    </Card.Body>
                </Card>
            </Modal>
        </>
    )
}

export default StdCertificateInputModal;